import React, { Fragment, Suspense } from "react";
import ModalWrapper from "./ModalWrapper";
import PreviewAndVisualization from "../modules/samples/containers/PreviewAndVisualization";
import ReactQuery from "../enhancers/reactQuery";

type PreviewVisualizationModalProps = {
  sha1: string;
  fileType: string;
  fileSubtype: string;
  typeDisplay: string | undefined;
  sourceId: number | undefined;
  threatStatus: number;
  relationshipId: number | undefined;
  onHide?: () => void;
  initialRulesetName?: string;
  initialRuleName?: string;
  yaraTestRunResultId?: number;
  sourceSampleSha1?: string;
};

const PreviewVisualizationModal = ({
  sha1,
  fileType,
  fileSubtype,
  typeDisplay,
  relationshipId,
  sourceId,
  threatStatus,
  onHide,
  initialRulesetName,
  initialRuleName,
  yaraTestRunResultId,
  sourceSampleSha1
}: PreviewVisualizationModalProps) => (
  <ReactQuery>
    <Suspense fallback={<Fragment />}>
      <ModalWrapper
        show
        size="lg"
        showHeader={false}
        className="preview-visualization-modal"
        onHide={onHide}
        fullHeight
      >
        {sha1 && (
          <PreviewAndVisualization
            sha1={sha1}
            fileType={fileType}
            fileSubtype={fileSubtype}
            typeDisplay={typeDisplay}
            relationshipId={relationshipId}
            sourceID={sourceId}
            threatStatus={threatStatus}
            showOpenYaraRulesetButton={false}
            initialRulesetName={initialRulesetName}
            initialRuleName={initialRuleName}
            yaraTestRunResultId={yaraTestRunResultId}
            sourceSampleSha1={sourceSampleSha1}
          />
        )}
      </ModalWrapper>
    </Suspense>
  </ReactQuery>
);

export default PreviewVisualizationModal;
